var render = function render(){var _vm=this,_c=_vm._self._c;return _c('V2Layout',[_c('div',{staticClass:"v2-page-wrap"},[_c('OriginalComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }